import { supabase } from './supabase';
import { ErrorDeApi } from './error-api';

/**
 * Una sesión viva de `auth.sessions`. `renovadaEn` es la última renovación del token, que ocurre
 * con el uso — no es presencia en vivo. `negocio*` solo llega en la lectura de plataforma.
 */
export interface SesionConectada {
  sesionId: string;
  usuario: string;
  nombre: string | null;
  rol: string;
  negocioId: string | null;
  negocio: string | null;
  esSintetico: boolean | null;
  creadaEn: string;
  renovadaEn: string;
  dispositivo: string | null;
  esActual: boolean;
}

function fila(s: Record<string, unknown>): SesionConectada {
  return {
    sesionId: s.sesion_id as string,
    usuario: s.usuario as string,
    nombre: (s.nombre as string) ?? null,
    rol: s.rol as string,
    negocioId: (s.negocio_id as string) ?? null,
    negocio: (s.negocio as string) ?? null,
    esSintetico: (s.es_sintetico as boolean) ?? null,
    creadaEn: s.creada_en as string,
    renovadaEn: s.renovada_en as string,
    dispositivo: (s.dispositivo as string) ?? null,
    esActual: Boolean(s.es_actual),
  };
}

export async function sesionesDelNegocio(negocioId: string): Promise<SesionConectada[]> {
  const { data, error, status } = await supabase.rpc('sesiones_del_negocio', { p_negocio: negocioId });
  if (error) throw new ErrorDeApi(error, status);
  return ((data ?? []) as Record<string, unknown>[]).map(fila);
}

export async function sesionesPlataforma(): Promise<SesionConectada[]> {
  const { data, error, status } = await supabase.rpc('sesiones_plataforma');
  if (error) throw new ErrorDeApi(error, status);
  return ((data ?? []) as Record<string, unknown>[]).map(fila);
}

/** Borra la sesión en el servidor: el dispositivo sale al refrescar o cuando su token caduque. */
export async function desconectarSesion(sesionId: string, motivo: string): Promise<void> {
  const { error, status } = await supabase.rpc('desconectar_sesion', { p_sesion: sesionId, p_motivo: motivo });
  if (error) throw new ErrorDeApi(error, status);
}

/** "hace 4 min" / "hace 3 h" / "hace 2 días", para las columnas de renovación. */
export function haceCuanto(iso: string): string {
  const minutos = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
  if (minutos < 60) return `hace ${minutos} min`;
  const horas = Math.round(minutos / 60);
  if (horas < 48) return `hace ${horas} h`;
  return `hace ${Math.round(horas / 24)} días`;
}
